export default __webpack_public_path__ + "static/media/horizontal-stripes.1ef6edda.webp";